import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const onlinePaymentEntity: Entity = {
  model: model,
  repository: repository,
}

export default onlinePaymentEntity
